import { Map } from 'immutable'

export const selectPMSections = (state) => state.pmSection.get('sections', Map())

export const selectPMSectionById = (sectionId) => (state) => state.pmSection.getIn(['sections', sectionId], Map())
